let messages = [
    {
      group: "groups/mountain-biking",
      groupname: "Mountain biking group",
      id: 0,
      parent: -1,
      primary: 'Brunch this week?',
      secondary: "I'll be in the neighbourhood this week. Let's grab a bite to eat",
      person: '/images/avatar/Anna.jpg',
    },
    {
      group: "groups/mountain-biking",
      groupname: "Mountain biking group",
      id: 1,
      parent: -1,
      primary: 'Birthday Gift',
      secondary: `Do you have a suggestion for a good present for John on his work
        anniversary. I am really confused & would love your thoughts on it.`,
      person: '/images/avatar/Anna.jpg',
    },
    {
      group: "groups/mountain-biking",
      groupname: "Mountain biking group",
      id: 2,
      parent: -1,
      primary: 'Recipe to try',
      secondary: 'I am try out this new BBQ recipe, I think this might be amazing',
      person: '/images/avatar/piero.jpg',
    },
    {
      group: "groups/swimming-club",
      groupname: "Swimming club",
      id: 3,
      parent: -1,
      primary: 'Referees needed for next compentition',
      secondary: 'Hi, we are still short of referees for the next race. Any volunteer? ',
      person: '/images/avatar/marzia.jpg',
    },
    {
      group: "groups/swimming-club",
      groupname: "Swimming club",
      id: 4,
      parent: -1,
      primary: "Fitness checks",
      secondary: "Please remember that all the athletes are required to provide a medical certificate by the end of this month",
      person: '/images/avatar/elena.jpg',
    },
    {
      group: "groups/mountain-biking",
      groupname: "Mountain biking group",
      parent: -1,
      primary: 'Discussion',
      secondary: `Menus that are generated by the bottom app bar (such as a bottom
        navigation drawer or overflow menu) open as bottom sheets at a higher elevation
        than the bar.`,
      person: '/images/avatar/marzia.jpg',
    },
    {
      group:"groups/general",
      groupname: "General",
      id: 5,
      parent: -1,
      primary: 'Summer BBQ',
      secondary: `As it is usual, we are organizing a BBQ to celebrate another year of great sport.`,
      person: '/images/avatar/pietro.jpg',
    },
    {
      id: 7,
      parent: 5,
      primary: 'Summer BBQ',
      secondary: `Great, any idea for the venue? Last year wasn't great `,
      person: '/images/avatar/pietro.jpg',
    },
    {
      id: 8,
      parent: 5,
      primary: 'Summer BBQ',
      secondary: `yes, let's be sure we have all the energy we need for the summer`,
      person: '/images/avatar/marzia.jpg',
    },
  ];

export default messages;